module.exports = __webpack_public_path__ + "img/img2.47a6cc6b.png";